<template>
  <div class="flex items-center gap-1">
    <div class="flex items-center gap-2">
      <alter-request
        :requester="{ id: transport.id, type: 'Transport', attr: 'appt_date' }"
      >
        <div class="flex items-center gap-1 relative">
          <div v-if="transport.confirmed_by">
            <i class="el-icon-chat-line-square bold" />
            {{ transport.confirmed_by }}
          </div>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.28033 2.46967C7.13968 2.32902 6.94891 2.25 6.75 2.25C6.55109 2.25 6.36032 2.32902 6.21967 2.46967C6.07902 2.61032 6 2.80109 6 3V4.5H5.25C4.45435 4.5 3.69129 4.81607 3.12868 5.37868C2.56607 5.94129 2.25 6.70435 2.25 7.5V18.75C2.25 19.5456 2.56607 20.3087 3.12868 20.8713C3.69129 21.4339 4.45435 21.75 5.25 21.75H18.75C19.5456 21.75 20.3087 21.4339 20.8713 20.8713C21.4339 20.3087 21.75 19.5456 21.75 18.75V7.5C21.75 6.70435 21.4339 5.94129 20.8713 5.37868C20.3087 4.81607 19.5456 4.5 18.75 4.5H18V3C18 2.80109 17.921 2.61032 17.7803 2.46967C17.6397 2.32902 17.4489 2.25 17.25 2.25C17.0511 2.25 16.8603 2.32902 16.7197 2.46967C16.579 2.61032 16.5 2.80109 16.5 3V4.5H7.5V3C7.5 2.80109 7.42098 2.61032 7.28033 2.46967ZM19.8107 8.18934C20.092 8.47064 20.25 8.85218 20.25 9.25V18.75C20.25 19.1478 20.092 19.5294 19.8107 19.8107C19.5294 20.092 19.1478 20.25 18.75 20.25H5.25C4.85218 20.25 4.47064 20.092 4.18934 19.8107C3.90804 19.5294 3.75 19.1478 3.75 18.75V9.25C3.75 8.85218 3.90804 8.47064 4.18934 8.18934C4.47064 7.90804 4.85218 7.75 5.25 7.75H18.75C19.1478 7.75 19.5294 7.90804 19.8107 8.18934ZM19.1758 10.8965C19.1758 11.5868 18.6161 12.1465 17.9258 12.1465C17.6834 12.1465 17.4572 12.0775 17.2656 11.9581C17.2416 11.9462 17.2182 11.9322 17.1957 11.9161C17.1734 11.9 17.1528 11.8825 17.1339 11.8637C16.8542 11.6345 16.6758 11.2863 16.6758 10.8965C16.6758 10.2061 17.2354 9.64648 17.9258 9.64648C18.6161 9.64648 19.1758 10.2061 19.1758 10.8965ZM16.6882 12.6233C16.9125 12.7843 16.9638 13.0967 16.8028 13.321L15.7122 14.8407C15.5511 15.065 15.2388 15.1164 15.0144 14.9554C14.7901 14.7944 14.7387 14.482 14.8997 14.2576L15.9904 12.738C16.1514 12.5136 16.4638 12.4623 16.6882 12.6233ZM13.2246 15.3776L10.9188 13.7044C10.9438 13.6059 10.957 13.5027 10.957 13.3965C10.957 12.7061 10.3974 12.1465 9.70703 12.1465C9.01667 12.1465 8.45703 12.7061 8.45703 13.3965C8.45703 13.5555 8.48673 13.7076 8.5409 13.8476L6.9793 15.2397C6.79748 15.1365 6.58726 15.0776 6.36328 15.0776C5.67293 15.0776 5.11328 15.6373 5.11328 16.3276C5.11328 17.018 5.67293 17.5776 6.36328 17.5776C7.05364 17.5776 7.61328 17.018 7.61328 16.3276C7.61328 16.2298 7.60204 16.1346 7.58077 16.0432L9.24595 14.5587C9.38862 14.6153 9.54419 14.6465 9.70703 14.6465C9.92362 14.6465 10.1273 14.5914 10.305 14.4945L12.6134 16.1696C12.5891 16.267 12.5762 16.3688 12.5762 16.4736C12.5762 17.164 13.1358 17.7236 13.8262 17.7236C14.5165 17.7236 15.0762 17.164 15.0762 16.4736C15.0762 15.7833 14.5165 15.2236 13.8262 15.2236C13.6081 15.2236 13.4031 15.2795 13.2246 15.3776Z"
              fill="currentColor"
            />
          </svg>
          <div v-if="transport.appt_date">
            {{ transport.appt_date | usFormat({ year: false }) }}
          </div>
          <div v-if="transport.appt_start">
            <i class="el-icon-time bold" />
            {{ formatTime }}
          </div>
        </div>
      </alter-request>
      <slot v-if="!transport.brokered">
        <div class="flex items-center gap-0.5">
          <svg
            width="20"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          <div v-if="transport.trucker_id">
            <div class="flex items-center gap-0.5 max-w-52 relative">
              <div class="ellipsis">
                {{ transport.trucker.name }}
                <popup
                  className="el-icon-link text-sm"
                  componentPath="components/html"
                  width="960"
                  :pivot-y="0"
                  :options="{
                    url: `/truckers/${transport.trucker_id}`,
                    title: transport.trucker.name,
                  }"
                />
              </div>
              <popup
                componentPath="pages/drivers/activity"
                width="400px"
                :inner="true"
                :pivot-y="0"
                :options="{
                  id: transport.trucker_id,
                  name: transport.trucker.name,
                }"
              >
                <svg
                  width="20"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                    d="M8.157 2.175a1.5 1.5 0 00-1.147 0l-4.084 1.69A1.5 1.5 0 002 5.251v10.877a1.5 1.5 0 002.074 1.386l3.51-1.453 4.26 1.763a1.5 1.5 0 001.146 0l4.083-1.69A1.5 1.5 0 0018 14.748V3.873a1.5 1.5 0 00-2.073-1.386l-3.51 1.452-4.26-1.763zM7.58 5a.75.75 0 01.75.75v6.5a.75.75 0 01-1.5 0v-6.5A.75.75 0 017.58 5zm5.59 2.75a.75.75 0 00-1.5 0v6.5a.75.75 0 001.5 0v-6.5z"
                  ></path>
                </svg>
              </popup>
              <span>
                <el-tooltip
                  :content="transport.viewed_at || 'Order is not viewed yet'"
                  placement="top"
                  :open-delay="1000"
                >
                  <a :class="transport.viewed_at ? 'green' : 'gray'">
                    <svg
                      width="20"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
                      ></path>
                      <path
                        clip-rule="evenodd"
                        fill-rule="evenodd"
                        d="M.664 10.59a1.651 1.651 0 010-1.186A10.004 10.004 0 0110 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0110 17c-4.257 0-7.893-2.66-9.336-6.41zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                      ></path>
                    </svg>
                  </a>
                </el-tooltip>
              </span>
              <div
                class="flex items-center gap-0.5 absolute top-3 left-0"
                v-if="transport.trucker2_id"
              >
                <div class="ellipsis italic text-[10px] text-gray-500">
                  {{ transport.trucker2.name }}
                  <popup
                    className="el-icon-link"
                    componentPath="components/html"
                    width="960"
                    :pivot-y="0"
                    :options="{
                      url: `/truckers/${transport.trucker2_id}`,
                      title: transport.trucker2.name,
                    }"
                  />
                </div>
                <popup
                  componentPath="pages/drivers/activity"
                  width="400px"
                  :inner="true"
                  :pivot-y="0"
                  :options="{
                    id: transport.trucker2_id,
                    name: transport.trucker2.name,
                  }"
                >
                  <svg
                    width="12"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      clip-rule="evenodd"
                      fill-rule="evenodd"
                      d="M8.157 2.175a1.5 1.5 0 00-1.147 0l-4.084 1.69A1.5 1.5 0 002 5.251v10.877a1.5 1.5 0 002.074 1.386l3.51-1.453 4.26 1.763a1.5 1.5 0 001.146 0l4.083-1.69A1.5 1.5 0 0018 14.748V3.873a1.5 1.5 0 00-2.073-1.386l-3.51 1.452-4.26-1.763zM7.58 5a.75.75 0 01.75.75v6.5a.75.75 0 01-1.5 0v-6.5A.75.75 0 017.58 5zm5.59 2.75a.75.75 0 00-1.5 0v6.5a.75.75 0 001.5 0v-6.5z"
                    ></path>
                  </svg>
                </popup>
              </div>
            </div>
          </div>
          <div v-else class="red">Pending Dispatch</div>
        </div>
      </slot>
    </div>
    <div v-if="transport.brokered" class="is-brokered">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.74902 7.37158V16.3442C5.74902 17.4488 6.64445 18.3442 7.74902 18.3442H16.6224"
          stroke="#2F80ED"
          stroke-width="1.8"
        />
        <path
          d="M16.6885 10.9565L6.37305 10.9565"
          stroke="#2F80ED"
          stroke-width="1.8"
        />
        <circle
          cx="5.92236"
          cy="4.55713"
          r="3.65713"
          stroke="#2F80ED"
          stroke-width="1.8"
        />
        <circle
          cx="19.1357"
          cy="10.8716"
          r="2.6"
          stroke="#2F80ED"
          stroke-width="1.8"
        />
        <circle
          cx="19.1357"
          cy="18.3442"
          r="2.6"
          stroke="#2F80ED"
          stroke-width="1.8"
        />
      </svg>
      {{ transport.carrier.name }}
      <slot v-if="transport.carrier_signature?.url">
        <a
          :href="transport.carrier_signature.url"
          target="_blank"
          :class="{
            gray: !transport.carrier_signature.signed,
            green: transport.carrier_signature.signed,
          }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M22 22H2v-2h20v2M6.2 17.3l-.7.7l-1.4-1.4L2.7 18l-.7-.7l1.4-1.4L2 14.5l.7-.7l1.4 1.4l1.4-1.4l.7.7l-1.4 1.4l1.4 1.4m10.02-2.87c0-.58-.72-1.23-2.16-1.97c-1.83-.92-3.06-1.67-3.7-2.22c-.65-.56-.97-1.18-.97-1.87c0-1.78.91-3.25 2.73-4.42c1.82-1.17 3.31-1.76 4.45-1.76c.74 0 1.28.13 1.61.39c.32.25.5.69.5 1.32c0 .28-.12.52-.37.73c-.24.2-.44.3-.57.3c-.11 0-.31-.1-.61-.29l-.58-.26c-.47 0-1.41.33-2.84 1c-1.42.66-2.13 1.41-2.13 2.25c0 .51.24.97.74 1.37c.5.42 1.39.93 2.68 1.53c1.03.47 1.86.97 2.5 1.54c.6.54.91 1.18.91 1.93c0 1.34-.94 2.41-2.83 3.17c-1.88.77-3.68 1.15-5.39 1.15c-1.44 0-2.19-.49-2.19-1.46c0-.36.19-.59.5-.75c.33-.16.66-.24 1-.24l.75.13l.72.13c.98 0 2.03-.16 3.16-.49c1.13-.32 1.83-.73 2.09-1.21Z"
            />
          </svg>
        </a>
      </slot>
    </div>
    <div v-else class="flex items-center gap-0.5">
      <el-popconfirm
        v-if="transport.notifiable"
        title="Are you sure to notify this driver?"
        confirmButtonText="Confirm"
        cancelButtonText="Cancel"
        @confirm="notifyTrucker"
      >
        <a
          :class="transport.notified ? 'green' : 'red'"
          slot="reference"
          @click.stop
        >
          <svg
            v-if="transport.notified"
            width="20"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0V0z"></path>
            <path
              d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-6.54 4.09c-.65.41-1.47.41-2.12 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z"
            ></path>
          </svg>
          <svg
            v-else
            width="20"
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.61 2.64548C20.1948 2.19021 21.6568 3.65224 21.2016 5.23705L17.1785 19.2417C16.5079 21.5761 13.3904 22.0197 12.1096 19.9629L10.3338 17.1113C9.84262 16.3226 9.96155 15.2974 10.6207 14.6383L14.4111 10.8479C14.8022 10.4567 14.8033 9.82357 14.4134 9.43373C14.0236 9.04389 13.3905 9.04497 12.9993 9.43614L9.20901 13.2265C8.54987 13.8856 7.52471 14.0046 6.73596 13.5134L3.88412 11.7375C1.82737 10.4567 2.27092 7.33918 4.60532 6.66858L18.61 2.64548Z"
            />
          </svg>
        </a>
      </el-popconfirm>
      <slot v-if="$store.envs.access_payable">
        <popup
          v-if="transport.trucker_id"
          componentPath="pages/containers/paycheck"
          width="850"
          height="auto"
          :click-to-close="false"
          :options="{
            id: transport.id,
            date: transport.appt_date,
            trucker: {
              id: transport.trucker.id,
              name: transport.trucker.name,
            },
          }"
        >
          <svg
            width="20"
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g data-name="Layer 2">
              <path
                d="M21,2H3A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM7,18H5V16H7Zm0-3H5V13H7Zm4,3H9V16h2Zm0-3H9V13h2Zm4,3H13V16h2Zm0-3H13V13h2Zm4,3H17V16h2Zm0-3H17V13h2Zm0-5a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1Z"
              ></path>
              <rect width="10" height="2" x="7" y="7"></rect>
            </g>
          </svg>
        </popup>
      </slot>
    </div>
  </div>
</template>

<script>
import { format, isValid, parse } from "date-fns";
import api from "@/default/utils/api";
import { dateTimeComputed } from "@/default/utils/computed";

export default {
  name: "ContainerTransportCompact",
  mixins: [api],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      transport: Object.assign({}, this.item),
    };
  },
  computed: {
    ...dateTimeComputed,
    formatTime() {
      const timeDate = parse(this.transport.appt_start, "HH:mm", new Date());
      if (!isValid(timeDate)) return "- / -";
      return format(timeDate, this.timeFormat);
    },
  },
  methods: {
    async notifyTrucker() {
      try {
        const response = await this.$http.patch(
          `/api/v1/transports/${this.transport.id}/notify`,
        );
        this.transport = response.data;
      } catch (err) {
        NApp.flashNoticeOut(err.response.data.errors, "error");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.is-brokered {
  @apply flex items-center gap-1 bg-sky-50 px-1 border rounded;
}
</style>
